const kurtlarVadisiQuestions = [
  {
    text: (
      <span style={{ fontSize: '14px', textAlign: 'justify' }}>
        Hangi Kurtlar Vadisi karakteri olduğunuzu öğrenin.
        <br />
        <br />
        Sorular yapay zeka tarafından üretilmiştir. Cevaplarınız kaydedilmemektedir.
      </span>
    ),
    options: [
      {
        text: '9 soruluk ankete ulaşmak için tıklayınız.',
        weight: 0,
      },
    ],
  },
  {
    text: 'İş hayatında nasıl bir strateji izlersiniz?',
    options: [
      {
        text: 'Hedeflerime ulaşmak için sessiz ama etkili yollar tercih ederim.',
        character: 'Abdülhey',
        weight: 2,
      },
      {
        text: 'Kendi kurallarım doğrultusunda ilerlerim, adaleti sağlamaya çalışırım.',
        character: 'Aslan Bey',
        weight: 2,
      },
      {
        text: 'İnsanlarla ilişkilerimi kullanarak stratejilerimi oluştururum.',
        character: 'Memati',
        weight: 2,
      },
      {
        text: 'Güçlü ve kararlı hareket ederim, her zaman kontrol bende olmalı.',
        character: 'Polat',
        weight: 2,
      },
    ],
  },
  {
    text: 'Tehlike anında nasıl hareket edersiniz?',
    options: [
      {
        text: 'Hızlı ve cesur bir şekilde harekete geçerim.',
        character: 'Memati',
        weight: 2,
      },
      {
        text: 'Durumu çözmek için zekamı kullanır ve stratejik hamleler yaparım.',
        character: 'Aslan Bey',
        weight: 2,
      },
      {
        text: 'Soğukkanlı kalır ve durumu analiz ederek hareket ederim.',
        character: 'Polat',
        weight: 2,
      },
      {
        text: 'Arka planda kalarak tehlikeyi ortadan kaldırmaya çalışırım.',
        character: 'Abdülhey',
        weight: 2,
      },
    ],
  },
  {
    text: 'Dostluk ve güven sizin için ne ifade eder?',
    options: [
      {
        text: 'Güvendiğim insanlarla ortak bir hedefe ulaşmak için çalışırım.',
        character: 'Aslan Bey',
        weight: 2,
      },
      {
        text: 'Dostlarımı her şeyin önüne koyarım ve onları her durumda korurum.',
        character: 'Abdülhey',
        weight: 2,
      },
      {
        text: 'Güven benim için her şeydir, ihanet affedilmez.',
        character: 'Polat',
        weight: 2,
      },
      {
        text: 'Dostlukta sadakat ve bağlılık en önemli değerlerdir.',
        character: 'Memati',
        weight: 2,
      },
    ],
  },
  {
    text: 'Gelecekle ilgili en büyük hedefiniz nedir?',
    options: [
      {
        text: 'Gizli operasyonlar yaparak ülkemin güvenliğini sağlamak.',
        character: 'Aslan Bey',
        weight: 2,
      },
      {
        text: 'Güçlü ve etkili bir lider olmak.',
        character: 'Polat',
        weight: 2,
      },
      {
        text: 'Güvenilir ve sadık dostlarla hayatımı sürdürmek.',
        character: 'Abdülhey',
        weight: 2,
      },
      {
        text: 'Sadık bir ekip kurup onlarla birlikte büyük başarılara imza atmak.',
        character: 'Memati',
        weight: 2,
      },
    ],
  },
  {
    text: 'Bir anlaşmazlık durumunda nasıl davranırsınız?',
    options: [
      {
        text: 'Direkt ve hızlı bir şekilde sorunu çözerim.',
        character: 'Memati',
        weight: 2,
      },
      {
        text: 'Diplomatik yollarla uzlaşma sağlamaya çalışırım.',
        character: 'Aslan Bey',
        weight: 2,
      },
      {
        text: 'Sessizce dinler ve doğru anı beklerim.',
        character: 'Abdülhey',
        weight: 2,
      },
      {
        text: 'Soğukkanlı kalarak mantıklı bir çözüm bulmaya çalışırım.',
        character: 'Polat',
        weight: 2,
      },
    ],
  },
  {
    text: 'Bir ekipte hangi rolü üstlenirsiniz?',
    options: [
      {
        text: 'Operasyonları yönetir ve görevleri tamamlarım.',
        character: 'Memati',
        weight: 2,
      },
      {
        text: 'Stratejileri belirler ve arka planda planlar yaparım.',
        character: 'Aslan Bey',
        weight: 2,
      },
      {
        text: 'Gölgede kalarak kritik destek sağlarım.',
        character: 'Abdülhey',
        weight: 2,
      },
      {
        text: 'Liderliği ele alır ve ekibi yönlendiririm.',
        character: 'Polat',
        weight: 2,
      },
    ],
  },
  {
    text: 'Adalet kavramı sizin için ne ifade eder?',
    options: [
      {
        text: 'Haksızlık karşısında sert bir duruş sergilerim.',
        character: 'Memati',
        weight: 2,
      },
      {
        text: 'Kanunların ve kuralların doğru uygulanmasını sağlarım.',
        character: 'Aslan Bey',
        weight: 2,
      },
      {
        text: 'Sessizce ama etkili bir şekilde adaleti yerine getiririm.',
        character: 'Abdülhey',
        weight: 2,
      },
      {
        text: 'Adaleti sağlamak için kendi yöntemlerimi kullanırım.',
        character: 'Polat',
        weight: 2,
      },
    ],
  },
  {
    text: 'En büyük korkunuz nedir?',
    options: [
      {
        text: 'Görevimi başaramamak.',
        character: 'Abdülhey',
        weight: 2,
      },
      {
        text: 'Ülkemin tehlikeye girmesi.',
        character: 'Aslan Bey',
        weight: 2,
      },
      {
        text: 'Sevdiklerimi kaybetmek.',
        character: 'Polat',
        weight: 2,
      },
      {
        text: 'İhanete uğramak.',
        character: 'Memati',
        weight: 2,
      },
    ],
  },
  {
    text: 'Stresli bir durumda nasıl tepki verirsiniz?',
    options: [
      {
        text: 'Anında harekete geçer ve durumu kontrol altına alırım.',
        character: 'Memati',
        weight: 2,
      },
      {
        text: 'Durumu analiz eder ve stratejik kararlar alırım.',
        character: 'Aslan Bey',
        weight: 2,
      },
      {
        text: 'Duygularımı gizler ve planımı uygularım.',
        character: 'Abdülhey',
        weight: 2,
      },
      {
        text: 'Soğukkanlılığımı korur ve mantıklı düşünürüm.',
        character: 'Polat',
        weight: 2,
      },
    ],
  },
];

export default kurtlarVadisiQuestions;
